import React from 'react';
import Trigger from '@magento/venia-ui/lib/components/Trigger/trigger';
import { CloseIcon, Modal } from '../../components';
import classes from '../SampleRequest/selectedSamplesList.module.css';
import defaultClasses from './designTeamMember.module.css';
import image from 'src/assets/designer_block_jason.jpg';

var DesignMemberModal = function DesignMemberModal(_ref) {
  var closeModal = _ref.closeModal,
      isOpen = _ref.isOpen,
      member = _ref.member;
  return React.createElement(Modal, {
    isOpen: isOpen,
    size: "full",
    toggleModal: closeModal,
    classes: {
      modalWrapper: 'bg-bronze'
    }
  }, React.createElement("div", {
    className: defaultClasses.modal
  }, React.createElement("div", {
    className: "container grid-cols-12 h-full pt-5 sm_pt-10"
  }, React.createElement("div", {
    className: "h-full"
  }, React.createElement("div", {
    className: "flex justify-end"
  }, React.createElement(Trigger, {
    action: closeModal,
    classes: {
      root: classes.closeButton
    },
    "aria-label": "Close design members modal"
  }, React.createElement("span", {
    className: "sr-only text-white"
  }, "Close design members modal"), React.createElement(CloseIcon, {
    isWhite: true
  }))), React.createElement("div", {
    className: "flex flex-col h-full justify-center px-10 2xl_px-44"
  }, React.createElement("div", null, React.createElement("h4", {
    className: defaultClasses.modalMemberName
  }, member.first_name, " ", member.last_name), React.createElement("img", {
    src: member.image_flip ? member.image_flip : image,
    alt: "Design member"
  }), React.createElement("div", {
    className: "grid grid-cols-3 mt-5"
  }, React.createElement("div", {
    className: "col-span-3 lg_col-start-2 lg_col-end-4 text-white leading-2"
  }, member.description))))))));
};

export default DesignMemberModal;